// For default MUI zIndex values please check: https://mui.com/material-ui/customization/z-index/
export const zIndex = {
  modal: 1200,
  drawer: 9999,
} as const;
